import { render } from "./FulfillmentOpsDashboard.vue?vue&type=template&id=4c8230ce&scoped=true"
import script from "./FulfillmentOpsDashboard.vue?vue&type=script&lang=js"
export * from "./FulfillmentOpsDashboard.vue?vue&type=script&lang=js"

import "./FulfillmentOpsDashboard.vue?vue&type=style&index=0&id=4c8230ce&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8230ce"]])

export default __exports__